import axios from "axios";

const HOST_API = process.env.REACT_APP_URL;

// Los endpoints de administraciones validan el rol server-side leyendo el
// JWT del header Authorization (no hay interceptor global que lo adjunte
// hoy en la app), por eso se manda explícitamente acá.
const authHeaders = () => {
  const token = JSON.parse(localStorage.getItem('user') || '{}').token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getAdministraciones = (soloNoDemo = true) =>
  axios.get(`${HOST_API}api/administraciones/GetAdministraciones`, {
    params: { soloNoDemo },
    headers: authHeaders(),
  });
